import React, { forwardRef } from 'react';
import classNames from 'classnames';
import { Icons } from '@beeline/design-tokens/js/iconfont/icons';
import { ButtonContainer } from './ButtonContainer';
import { Typography } from '../../Typography';
import { Icon } from '../../Icon';
import { IconButton } from '../../IconButton';
import "./styles.css";
export var Banner = forwardRef(function (_a, ref) {
    var title = _a.title, _b = _a.type, type = _b === void 0 ? 'horizontal' : _b, _c = _a.color, color = _c === void 0 ? 'info' : _c, actions = _a.actions, onClose = _a.onClose, iconName = _a.iconName, className = _a.className;
    return (React.createElement("div", { ref: ref, className: classNames('banner banner-container', "banner__type-" + type, "banner__color-" + color, !!onClose && 'banner__close-button', className) },
        React.createElement("div", { className: 'banner-title' },
            React.createElement(Typography, { variant: 'body3', className: 'banner-title-text' },
                iconName && (React.createElement(Icon, { size: 'medium', iconName: iconName, className: 'banner-title-icon' })),
                title)),
        actions && (React.createElement(ButtonContainer, { actions: actions, className: 'banner-actions' })),
        onClose && (React.createElement(IconButton, { size: 'large', className: 'icon-button-close icon-close', onClick: onClose, iconName: Icons.Close }))));
});
